import React from 'react';

const RecruiterLetterViewer = ({ letter, onClose }) => {
  if (!letter) return null;

  const {
    ref_number      = 'OUK/HR/46/Vol.1',
    issue_date      = new Date().toISOString().split('T')[0],
    full_name       = 'Recruiter Full Name',
    id_passport     = 'N/A',
    email           = 'recruiter@example.com',
    subject         = 'EXTENSION OF TEMPORARY ENGAGEMENT AS A STUDENT RECRUITER',
    resolved_body   = '',
    body_template   = '',
    office_heading  = 'OFFICE OF THE VICE-CHANCELLOR',
    signatory_name  = 'PROF. ELIJAH OMWENGA',
    signatory_title = 'VICE-CHANCELLOR',
    signature_image = null,
    cc_list         = 'Deputy Vice-Chancellor P&I\nDeputy Vice Chancellor, AA\nHoD, Corporate Communication & Marketing',
  } = letter;

  /* ── Helpers ──────────────────────────────────────── */
  const formatDateOrdinal = (dateStr) => {
    try {
      const d = dateStr ? new Date(dateStr) : new Date();
      const day = d.getDate();
      const months = [
        'January','February','March','April','May','June',
        'July','August','September','October','November','December',
      ];
      const suffixes = { 1: 'st', 2: 'nd', 3: 'rd' };
      const suffix =
        [11, 12, 13].includes(day) ? 'th' :
        suffixes[day % 10] || 'th';
      return `${day}${suffix} ${months[d.getMonth()]} ${d.getFullYear()}`;
    } catch { return dateStr; }
  };

  const formatSalutation = (name) => {
    if (!name) return 'Dear Recruiter,';
    return `Dear ${name.trim().split(/\s+/)[0]},`;
  };

  /* ── Body text ─────────────────────────────────────── */
  let bodyText = resolved_body;
  if (!bodyText && body_template) {
    const salutation = formatSalutation(full_name);
    bodyText = body_template
      .replace(/\{full_name\}/g,     full_name)
      .replace(/\{id_passport\}/g,   id_passport)
      .replace(/\{email\}/g,         email)
      .replace(/\{ref_no\}/g,        ref_number)
      .replace(/\{date\}/g,          formatDateOrdinal(issue_date))
      .replace(/\{salutation\}/g,    salutation);
  }

  const ccItems = cc_list ? cc_list.split('\n').filter(Boolean) : [];

  /* ── Print / PDF ─────────────────────────────────── */
  const handlePrint = () => {
    const el = document.getElementById('printable-letter-content');
    if (!el) return;

    const w = window.open('', '_blank');
    w.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>${subject}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,700;1,400&display=swap');
    @page { size: A4; margin: 18mm 18mm 22mm 18mm; }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'EB Garamond', 'Times New Roman', serif;
      color: #1a1a1a; font-size: 13.5pt; line-height: 1.6;
    }
    .header-org {
      font-family: Arial, sans-serif; font-weight: 800;
      font-size: 15pt; text-align: center;
      color: #037b90; margin: 8px 0 3px;
      text-transform: uppercase; letter-spacing: 0.5px;
    }
    .header-dept {
      font-family: Arial, sans-serif; font-weight: 700;
      font-size: 11.5pt; text-align: center;
      color: #1a1a1a; text-transform: uppercase; margin-bottom: 4px;
    }
    hr.header-rule { border: none; border-top: 1.2px solid #777; margin-bottom: 22px; }
    .meta-row { display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 22px; font-size: 12pt; }
    .recipient-block { margin-bottom: 22px; }
    .recipient-name { font-weight: 700; font-size: 13pt; margin-bottom: 3px; }
    .salutation { margin-bottom: 18px; }
    .subject-line { font-weight: 700; margin-bottom: 20px; text-decoration: underline; text-transform: uppercase; }
    .body-content p { margin-bottom: 14px; text-align: justify; }
    .signoff { margin-bottom: 8px; margin-top: 24px; }
    .sig-curve { display: block; margin-bottom: 4px; }
    .sig-name { font-weight: 700; font-size: 12pt; }
    .sig-title { font-weight: 700; font-size: 11pt; text-decoration: underline; margin-bottom: 20px; }
    .cc-block { font-size: 11pt; margin-top: 16px; border-top: 1px solid #ccc; padding-top: 12px; }
    .cc-row { display: flex; gap: 8px; }
    .cc-label { font-weight: 600; min-width: 70px; }
    /* Footer */
    .footer {
      margin-top: 40px; padding-top: 12px;
      border-top: 3px solid #037b90;
      font-family: Arial, sans-serif; font-size: 9pt; color: #333;
    }
    .footer-inner { display: flex; justify-content: space-between; align-items: flex-end; gap: 12px; }
    .footer-bars { display: flex; gap: 4px; margin-bottom: 5px; }
    .bar-teal   { height: 8px; width: 44px; background: #037b90; border-radius: 2px; }
    .bar-orange { height: 8px; width: 72px; background: #ff7f50; border-radius: 2px; }
    .footer-tel { font-weight: 700; margin-top: 4px; font-size: 9.5pt; }
    .footer-center { text-align: center; }
    .footer-right  { text-align: right; }
    .footer-link { color: #037b90; font-weight: 600; }
  </style>
</head>
<body>
  ${el.innerHTML}
  <script>window.onload = function(){ window.print(); window.close(); };<\/script>
</body>
</html>`);
    w.document.close();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>

        {/* ── Toolbar ──────────────────────────────────── */}
        <div style={styles.toolbar}>
          <div style={styles.toolbarLeft}>
            <span style={styles.toolbarTitle}>Official Letter Preview</span>
            <span style={styles.officialBadge}>OUK Letterhead</span>
          </div>
          <div style={styles.toolbarRight}>
            <button
              onClick={handlePrint}
              className="btn btn-primary"
              style={{ gap: 8 }}
            >
              🖨️ Print / Download PDF
            </button>
            <button onClick={onClose} style={styles.closeBtn} title="Close">
              <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>

        {/* ── Document Area ─────────────────────────────── */}
        <div style={styles.documentArea}>
          <div
            id="printable-letter-content"
            style={styles.letterPage}
          >
            {/* ─── Letter Header ─── */}
            <div style={styles.letterHeader}>

              {/* Official OUK System Logo Image */}
              <div style={{ textAlign: 'center', marginBottom: 8 }}>
                <img
                  src="/assets/logo.png"
                  alt="Open University of Kenya"
                  style={{ height: '75px', margin: '0 auto 8px', display: 'block', objectFit: 'contain' }}
                />
              </div>

              <div style={styles.officeDept}>{office_heading || 'OFFICE OF THE VICE-CHANCELLOR'}</div>
              <hr style={styles.headerRule} />
            </div>

            {/* ─── Ref / Date Row ─── */}
            <div style={styles.metaRow}>
              <span style={styles.metaText}>REF: <strong>{ref_number}</strong></span>
              <span style={styles.metaText}>DATE: <strong>{formatDateOrdinal(issue_date)}</strong></span>
            </div>

            {/* ─── Recipient ─── */}
            <div style={styles.recipientBlock}>
              <div style={styles.recipientName}>{full_name}</div>
              <div style={styles.recipientDetail}>ID No: {id_passport || 'N/A'}</div>
              <div style={styles.recipientDetail}>Email: {email}</div>
            </div>

            {/* ─── Salutation ─── */}
            <div style={styles.salutation}>{formatSalutation(full_name)}</div>

            {/* ─── Subject ─── */}
            <div style={styles.subjectLine}>RE: {subject}</div>

            {/* ─── Body ─── */}
            <div style={styles.bodyContent}>
              {bodyText.split('\n\n').map((para, i) => (
                <p key={i} style={styles.bodyPara}>{para}</p>
              ))}
            </div>

            {/* ─── Sign-off ─── */}
            <div style={styles.signoff}>Yours sincerely,</div>

            {/* ─── Signature (Image/Canvas or Default Curve) ─── */}
            {signature_image ? (
              <div style={{ margin: '8px 0 6px' }}>
                <img
                  src={signature_image}
                  alt="Signatory Signature"
                  style={{ maxHeight: '65px', maxWidth: '220px', display: 'block', objectFit: 'contain' }}
                />
              </div>
            ) : (
              <svg width="180" height="50" viewBox="0 0 180 50" style={{ display: 'block', margin: '10px 0 6px' }}>
                <path
                  d="M 12 38 C 30 10, 58 10, 72 32 C 86 52, 108 12, 128 25 C 148 38, 162 20, 172 30"
                  fill="none" stroke="#1a1a1a" strokeWidth="2.2"
                  strokeLinecap="round" strokeLinejoin="round"
                />
                <text x="5" y="47" fontFamily="serif" fontSize="9" fontStyle="italic" fill="#444">
                  for {signatory_name}
                </text>
              </svg>
            )}

            <div style={styles.signatoryName}>{signatory_name}</div>
            <div style={styles.signatoryTitle}>{signatory_title}</div>

            {/* ─── CC ─── */}
            {ccItems.length > 0 && (
              <div style={styles.ccBlock}>
                <div style={styles.ccRow}>
                  <span style={styles.ccLabel}>Copy to:</span>
                  <div>
                    {ccItems.map((item, i) => <div key={i}>{item}</div>)}
                  </div>
                </div>
              </div>
            )}

            {/* ─── Footer ─── */}
            <div style={styles.footer}>
              <div style={styles.footerInner}>

                {/* Left — colour bars + tel */}
                <div>
                  <div style={styles.footerBars}>
                    <span style={styles.barTeal}  />
                    <span style={styles.barOrange} />
                  </div>
                  <div style={styles.footerTel}>TEL: 0702 212 212 / 0703 211 211</div>
                </div>

                {/* Centre — address */}
                <div style={styles.footerCenter}>
                  <div style={styles.footerBold}>Konza Technopolis</div>
                  <div>P.O. Box 2440, 00606 Nairobi, Kenya</div>
                  <div style={styles.footerHandle}>@OpenUniKenya</div>
                </div>

                {/* Right — contact */}
                <div style={styles.footerRight}>
                  <div>info@ouk.ac.ke</div>
                  <div style={styles.footerLink}>https://ouk.ac.ke</div>
                  <div style={styles.footerHandle}>@OpenUniKenya</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

/* ── Styles ─────────────────────────────────────────── */
const LETTER_FONT = "'EB Garamond', 'Times New Roman', Georgia, serif";

const styles = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 1100,
    background: 'rgba(15,23,42,0.65)',
    display: 'flex', alignItems: 'flex-start',
    justifyContent: 'center', padding: '32px 16px',
    overflowY: 'auto',
  },
  modal: {
    background: '#fff', borderRadius: 14,
    boxShadow: '0 32px 64px rgba(0,0,0,0.35)',
    width: '100%', maxWidth: 860,
    display: 'flex', flexDirection: 'column',
    overflow: 'hidden',
  },

  /* Toolbar */
  toolbar: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 20px', background: '#fafbfc',
    borderBottom: '1px solid var(--border-color)', gap: 12,
  },
  toolbarLeft:  { display: 'flex', alignItems: 'center', gap: 10 },
  toolbarRight: { display: 'flex', alignItems: 'center', gap: 10 },
  toolbarTitle: { fontWeight: 700, fontSize: 14, color: 'var(--text-primary)' },
  officialBadge: {
    background: '#e0f7fa', color: '#037b90',
    fontSize: 11, fontWeight: 700,
    padding: '3px 10px', borderRadius: 99,
  },
  closeBtn: {
    background: 'none', border: 'none', cursor: 'pointer',
    color: 'var(--text-secondary)', padding: 6,
    borderRadius: 6, display: 'flex', alignItems: 'center',
    transition: 'background 0.15s',
  },

  /* Document area — grey surround */
  documentArea: {
    background: '#e8ecf0', padding: '28px 20px',
    overflowY: 'auto', maxHeight: 'calc(90vh - 64px)',
    display: 'flex', justifyContent: 'center',
  },

  /* The A4-ish paper */
  letterPage: {
    background: '#fff',
    padding: '40px 52px 48px',
    width: '100%', maxWidth: 700,
    boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
    fontFamily: LETTER_FONT,
    fontSize: 14,
    color: '#1a1a1a',
    lineHeight: 1.65,
  },

  /* Letter Header */
  letterHeader: { marginBottom: 18 },
  officeDept: {
    textAlign: 'center', fontFamily: 'Arial, sans-serif',
    fontWeight: 800, fontSize: 15, textTransform: 'uppercase',
    letterSpacing: '0.05em', color: '#1a1a1a', margin: '6px 0 8px',
  },
  headerRule: { border: 'none', borderTop: '1.2px solid #888', marginBottom: 24 },

  /* Meta row */
  metaRow: {
    display: 'flex', justifyContent: 'space-between',
    fontFamily: 'Arial, sans-serif', fontWeight: 700,
    fontSize: 13, marginBottom: 24,
  },
  metaText: { fontWeight: 400 },

  /* Recipient */
  recipientBlock: { marginBottom: 22 },
  recipientName:  { fontWeight: 700, fontSize: 15, marginBottom: 3 },
  recipientDetail:{ fontSize: 13.5, color: '#333' },

  salutation: { marginBottom: 18, fontSize: 14 },

  subjectLine: {
    fontFamily: 'Arial, sans-serif', fontWeight: 700,
    fontSize: 13, textDecoration: 'underline',
    textTransform: 'uppercase', marginBottom: 22,
    letterSpacing: '0.02em',
  },

  bodyContent: { marginBottom: 28 },
  bodyPara:    { marginBottom: 14, textAlign: 'justify', fontSize: 14 },

  signoff: { marginBottom: 4, fontSize: 14 },

  signatoryName: {
    fontFamily: 'Arial, sans-serif', fontWeight: 800,
    fontSize: 13, marginBottom: 2,
  },
  signatoryTitle: {
    fontFamily: 'Arial, sans-serif', fontWeight: 700,
    fontSize: 12, textDecoration: 'underline', marginBottom: 24,
  },

  /* CC */
  ccBlock: {
    fontSize: 12, marginTop: 16,
    borderTop: '1px solid #ddd', paddingTop: 14, marginBottom: 28,
  },
  ccRow:   { display: 'flex', gap: 8 },
  ccLabel: { fontWeight: 700, minWidth: 70, flexShrink: 0 },

  /* Footer */
  footer: {
    marginTop: 28, paddingTop: 12,
    borderTop: '3px solid #037b90',
    fontFamily: 'Arial, sans-serif', fontSize: 10.5, color: '#444',
  },
  footerInner: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'flex-end', gap: 12,
  },
  footerBars:  { display: 'flex', gap: 5, marginBottom: 6 },
  barTeal:     { height: 9, width: 44, background: '#037b90', borderRadius: 2, display: 'inline-block' },
  barOrange:   { height: 9, width: 72, background: '#ff7f50', borderRadius: 2, display: 'inline-block' },
  footerTel:   { fontWeight: 700, fontSize: 11 },
  footerCenter:{ textAlign: 'center' },
  footerBold:  { fontWeight: 700 },
  footerHandle:{ color: '#037b90', fontWeight: 700, fontSize: 10 },
  footerRight: { textAlign: 'right' },
  footerLink:  { color: '#037b90', fontWeight: 600 },
};

export default RecruiterLetterViewer;
